import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import indlusLogo from '../../../assets/indlusr.png'
import LanguageSwitcher from '../../../shared/components/LanguageSwitcher'

// Ligações ainda sem destino definido — colocar o URL real quando existir.
const CONTACT_HREF = '#'
const BOOK_DEMO_HREF = '#'

/** Barra de topo das páginas públicas (login / registo / recuperar palavra-passe):
 *  logótipo à esquerda, acções de contacto à direita, fora do cartão.
 *  Fundo branco com borda inferior, igual à Navbar da app. */
export default function AuthTopBar() {
  const { t } = useTranslation('auth')

  return (
    <Box
      component="header"
      sx={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        columnGap: 1.5,
        rowGap: 1,
        px: { xs: 2, sm: 3 },
        py: { xs: 0.75, sm: 1 },
        bgcolor: 'background.paper',
        borderBottom: '1px solid', borderBottomColor: 'divider',
        color: 'text.primary',
      }}
    >
      <Box
        component="img"
        src={indlusLogo}
        alt="Indlus"
        sx={{ height: { xs: 34, sm: 40 }, width: 'auto', display: 'block', flexShrink: 0 }}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'flex-end', gap: { xs: 1, sm: 1.5 } }}>
        <LanguageSwitcher />
        <Button
          component="a"
          href={CONTACT_HREF}
          variant="text"
          size="small"
          sx={{ color: 'text.secondary', fontWeight: 500 }}
        >
          {t('brand.contact')}
        </Button>
        <Button
          component="a"
          href={BOOK_DEMO_HREF}
          variant="contained"
          size="small"
          disableElevation
          sx={{ px: 1.5, py: 0.5, fontSize: '0.8125rem', minWidth: 0 }}
        >
          {t('brand.bookDemo')}
        </Button>
      </Box>
    </Box>
  )
}
